import { render, staticRenderFns } from "./CustomFieldEditModal.vue?vue&type=template&id=3f5d288a&"
import script from "./CustomFieldEditModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports